import React from "react";
import styled from "styled-components";

const TextInputStyle = styled.div`
  background-color: magenta;
  display: grid;
  grid-template-columns: 1fr 3fr;
  margin: 20px;
`;

const InputStyle = styled.input`
  width: 100%;
`;

const TextInput = ({ label, ...rest }) => {
  return (
    <TextInputStyle>
      <label>{label}</label>
      <InputStyle {...rest}></InputStyle>
    </TextInputStyle>
  );
};

export default TextInput;
